import type { TaxForecast } from '@/types/simulation'

interface Props {
  forecast: TaxForecast
}

export function TaxForecastCard({ forecast }: Props) {
  const fmtEur = (s: string) =>
    `${Number(s).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`
  const pl = Number(forecast.realized_pl_eur)
  const plClass = pl > 0 ? 'text-gain' : pl < 0 ? 'text-loss' : 'text-muted'

  return (
    <div className="border border-hairline bg-panel p-4">
      <div className="tracked-caps mb-3 text-[10px] text-faint">Steuer-Forecast (HR)</div>
      {forecast.warning && (
        <div className="mb-2 text-xs text-bernstein-dim">⚠ {forecast.warning}</div>
      )}
      <div className="space-y-1 text-sm text-ink">
        <div className="flex justify-between">
          <span className="text-muted">≥ 2 J (steuerfrei)</span>
          <strong className="font-mono">{forecast.qty_tax_free} Stk</strong>
        </div>
        <div className="flex justify-between">
          <span className="text-muted">&lt; 2 J (steuerpflichtig)</span>
          <strong className="font-mono">{forecast.qty_taxable} Stk</strong>
        </div>
        <div className="flex justify-between">
          <span className="text-muted">Realisierter G/V</span>
          <strong className={`font-mono ${plClass}`}>
            {pl > 0 ? '+' : ''}
            {fmtEur(forecast.realized_pl_eur)}
          </strong>
        </div>
        <div className="flex justify-between">
          <span className="text-muted">Geschätzte KESt</span>
          <strong className="font-mono">{fmtEur(forecast.kest_eur)}</strong>
        </div>
      </div>
    </div>
  )
}
